import * as types from './mutation-types';

export const toggleModalProduct = async (context) => {
  context.commit(types.SET_TOGGLE_MODAL_PRODUCT);
};

export const toggleModalPriceUpdate = async (context) => {
  context.commit(types.SET_TOGGLE_MODAL_PRICE_UPDATE);
};

export const toggleModalImportXml = async (context) => {
  context.commit(types.SET_TOGGLE_MODAL_IMPORT_XML);
};

export const toggleModalManifestedXmls = async (context) => {
  context.commit(types.SET_TOGGLE_MODAL_MANIFESTED_XMLS);
};

export const toggleModalCancelPurchase = async (context) => {
  context.commit(types.SET_TOGGLE_MODAL_CANCEL_PURCHASE);
};

export const toggleModalChangeCFOP = async (context) => {
  context.commit(types.SET_TOGGLE_MODAL_CHANGE_CFOP);
};

export const setModalCancelPurchaseIds = async (context, payload) => {
  const purchaseIds = payload.filter((e) => e.id).map((e) => e.id);
  context.commit(types.SET_MODAL_CANCEL_PURCHASE_IDS, purchaseIds);
};

export const setLoadingTabProduct = async (context, payload) => {
  context.commit(types.SET_LOADING_TAB_PRODUCT, payload);
};

export const setLoadingTabPurchase = async (context, payload) => {
  context.commit(types.SET_LOADING_TAB_PURCHASE, payload);
};
